import { useState, useEffect } from "react"
import debounce from "lodash/debounce"

const getInitWindow = () => {
  if (typeof window !== "undefined") {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }
  return {
    width: 0,
    height: 0,
  }
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getInitWindow())

  useEffect(() => {
    function handleResize() {
      const { innerWidth: width, innerHeight: height } = window
      const size = {
        width,
        height,
      }
      setWindowDimensions(size)
    }

    window.addEventListener("resize", debounce(handleResize, 100))
    return () =>
      window.removeEventListener("resize", debounce(handleResize, 100))
  }, [])

  return windowDimensions
}
